module.exports = __webpack_public_path__ + "assets/img/prd3-6.7b65c516.jpg";